import { usePlanetStore } from '../store/planetStore';
import type { Planet } from '@kaeliux/shared';

interface PlanetResource {
    state: {
        planet: Planet | null;
        isLoading: boolean;
        isTicking: boolean;
    };
    requestTick: () => Promise<void>;
}

/**
 * The active planet plus its tick control, for pages that render planet state.
 *
 * Reads straight from `planetStore` — there is no separate provider mirroring
 * it any more. The periodic ticking that used to live in
 * `PlanetResourceProvider` now runs once, app-wide, in `useGameLoop`.
 *
 * `isLoading` is derived rather than taken from `planetStore.isLoading`
 * deliberately: that flag goes true during every background `loadPlanet`, and
 * pages gate a full-screen "Loading…" on it, so wiring it through would flash
 * that overlay over a rendered page once a minute.
 */
export function usePlanetResource(): PlanetResource {
    const planet = usePlanetStore((s) => s.currentPlanet);
    const isTicking = usePlanetStore((s) => s.isTicking);
    const requestTick = usePlanetStore((s) => s.tickCurrentPlanet);

    return { state: { planet, isLoading: planet === null, isTicking }, requestTick };
}
